import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "./api";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: (failureCount, error) =>
        error instanceof ApiError && error.status >= 500 && failureCount < 2,
      refetchOnWindowFocus: false,
    },
  },
});

export const queryKeys = {
  ips: ["ips"] as const,
  ip: (id: string) => ["ips", id] as const,
  favorites: ["me", "favorites"] as const,
};
